import React, { useMemo, useState, useEffect } from 'react';
import classes from './TablePagination.module.css';
import PaginationNavButton from './PaginationNavButton/PaginationNavButton';
import PaginationPageNumbers from './PaginationPageNumbers/PaginationPageNumbers';

const PAGE_SLOTS = 4;

const TablePagination = ({ currentPage, totalPages, onPageChange, texts = {} }) => {
  
  const [windowStart, setWindowStart] = useState(currentPage);
  
  useEffect(() => {
    if (currentPage < windowStart || currentPage > windowStart + PAGE_SLOTS - 1) {
      setWindowStart(Math.max(1, Math.min(currentPage, totalPages - PAGE_SLOTS + 1)));
    }
  }, [currentPage, totalPages, windowStart]);

  const pageSlots = useMemo(() => {
    if (totalPages <= 1) return [];
    const from = windowStart;
    const to = Math.min(totalPages, windowStart + (PAGE_SLOTS - 1));
    const filled = [];
    for (let p = from; p <= to; p++) filled.push(p);
    const slots = new Array(PAGE_SLOTS).fill(null);
    filled.forEach((p, i) => { slots[i] = p; });
    return slots;
  }, [totalPages, windowStart]);

  const handleNext = () => {
    onPageChange((p) => Math.min(totalPages, p + 1));
    setWindowStart((prev) => Math.min(prev + 1, Math.max(1, totalPages - PAGE_SLOTS + 1)));
  };

  const handlePrev = () => {
    onPageChange((p) => Math.max(1, p - 1));
    setWindowStart((prev) => Math.max(1, prev - 1));
  };

  const pageLabel = texts?.pageOf ? texts.pageOf.replace('{current}', currentPage).replace('{total}', totalPages) : `${texts.pageOf} ${currentPage} ${texts.of} ${totalPages}`;

  return (
    <div className={classes.bar}>
      <span className={classes.label}>{pageLabel}</span>
      <div className={classes.buttons}>
        <PaginationNavButton disabled={currentPage <= 1} onClick={handlePrev} text={texts?.prev} />
        <PaginationPageNumbers pageSlots={pageSlots} currentPage={currentPage} onPageSelect={onPageChange} />
        <PaginationNavButton disabled={currentPage >= totalPages} onClick={handleNext} text={texts?.next} />
      </div>
    </div>
  );
};

export default TablePagination;
